import React, { useState, useContext } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Modal,
  Box,
  Grid,
  Card,
  CardActionArea,
  IconButton,
  Typography,
  Divider,
  Stack,
  Chip,
} from "@mui/material"

import ModalSelectPlantilla from "./modalSelectPlantilla"
import ModalCreateFromExcel from "./ModalCreateFromExcel"
import ContactContext from "context/contact/contactContext"
import useEntitlementGuard from "hooks/useEntitlementGuard"
import {
  IMPORT_TEMPLATE,
  IMPORT_TCQ,
  IMPORT_PLANHOPPER,
} from "constants/entitlements"

import excel from "assets/customIcons/excel.svg"
import excelPlanhopper from "assets/customIcons/excelPlanhopper.svg"
import pdfPlanhopperAI from "assets/customIcons/pdfPlanhopperAI.svg"

import bc3 from "assets/customIcons/bc3.svg"

import startPlanhopper from "assets/customIcons/logos/startPlanhopper.svg"
import plantilla from "assets/customIcons/plantilla.svg"
import higherThan from "assets/customIcons/ArrowHigherThan.svg"

function getModalStyle() {
  const top = 50
  const left = 50
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(theme => ({
  modal: {
    position: "absolute",
    width: "920px",
    maxWidth: "100%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: 6,
    overflowY: "auto",
    overflowX: "hidden",
  },
}))

const ModalSelectTypeProject = ({
  modalNew,
  setModalNew,
  setmodal_first,
  onClickPersonalModal,
}) => {
  const [modalStyle] = useState(getModalStyle)
  const classes = useStyles()
  const handleCargar = () => {
    setModalNew(false)
    setmodal_first(true)
  }
  const [openModalPlantilla, setOpenModalPlantilla] = useState(false)

  const [openCreateFromExcel, setOpenCreateFromExcel] = useState(false)
  const [openCreateFromOther, setOpenCreateFromOther] = useState(false)
  const [openCreateFromPDFAI, setOpenCreateFromPDFAI] = useState(false)
  const [openModalExcel, setOpenModalExcel] = useState(false)
  const [openModalOther, setOpenModalOther] = useState(false)
  const [openModalPDFAI, setOpenModalPDFAI] = useState(false)

  const [openModalTCQ, setOpenModalTCQ] = useState(false)
  const [openCreateFromTCQ, setOpenCreateFromTCQ] = useState(false)

  const { Contacts } = useContext(ContactContext)

  const [checkEntitlement, entitlementDialog] = useEntitlementGuard()

  const importTemplate = () => {
    if (!checkEntitlement(IMPORT_TEMPLATE, "Importar plantilla")) return

    setOpenModalPlantilla(true)
    setModalNew(false)
  }

  const importTCQ = () => {
    if (!checkEntitlement(IMPORT_TCQ, "Importar plantilla TCQ")) return

    setOpenCreateFromTCQ(true)
    setOpenModalTCQ(true)
    setModalNew(false)
  }

  const importExcel = () => {
    if (!checkEntitlement(IMPORT_PLANHOPPER, "Importar Excel Planhopper"))
      return

    setOpenCreateFromExcel(true)
    setOpenModalExcel(true)
    setModalNew(false)
  }

  const importPDFWithAI = () => {
    setOpenCreateFromPDFAI(true)
    setOpenModalPDFAI(true)
    setModalNew(false)
  }

  return (
    <>
      <Modal open={modalNew} onClose={() => setModalNew(false)}>
        <Box
          data-testid="new-budget-type-modal"
          style={modalStyle}
          className={classes.modal}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {i18n.t("Nuevo presupuesto")}
            </Typography>
            <IconButton
              data-testid="new-budget-type-modal-close"
              onClick={() => setModalNew(false)}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ mt: 2, px: 2, pb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <Card variant="outlined">
                    <CardActionArea
                      data-testid="new-budget-option-start-planhopper"
                      onClick={handleCargar}
                      sx={{ height: 115 }}
                      data-element="startPlanhopper"
                    >
                      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                        <img
                          src={startPlanhopper}
                          height="75"
                          width="105"
                          alt="start"
                        />
                        <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                            {i18n.t("Comienza con Planhopper")}
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {
                              "Construye tu presupuesto utilizando las partidas de las bases de datos"
                            }
                          </Typography>
                        </Box>
                        <img
                          src={higherThan}
                          width="24"
                          height="15"
                          alt="arrow"
                        />
                      </Box>
                    </CardActionArea>
                  </Card>

                  <Card variant="outlined">
                    <CardActionArea
                      data-testid="new-budget-option-reference-template"
                      onClick={importTemplate}
                      data-element="startTemplate"
                      sx={{ height: 115 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                        <img
                          src={plantilla}
                          height="75"
                          width="105"
                          alt="plantilla"
                        />
                        <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                            {i18n.t("Plantilla de referencia")}
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {
                              "Selecciona una plantilla y empieza a trabajar en tu presupuesto"
                            }
                          </Typography>
                        </Box>
                        <img
                          src={higherThan}
                          width="24"
                          height="15"
                          alt="arrow"
                        />
                      </Box>
                    </CardActionArea>
                  </Card>

                  <Card variant="outlined">
                    <CardActionArea
                      data-testid="new-budget-option-excel-planhopper"
                      onClick={importExcel}
                      sx={{ height: 115 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                        <img
                          src={excelPlanhopper}
                          height="75"
                          width="105"
                          alt="excel-planhopper"
                        />
                        <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                            {i18n.t("Plantilla Excel Planhopper")}
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {
                              "Descarga la plantilla Excel de Planhopper, rellénala y cárgala."
                            }
                          </Typography>
                        </Box>
                        <img
                          src={higherThan}
                          width="24"
                          height="15"
                          alt="arrow"
                        />
                      </Box>
                    </CardActionArea>
                  </Card>
                </Stack>
              </Grid>

              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <Card variant="outlined">
                    <CardActionArea
                      data-testid="new-budget-option-bc3"
                      onClick={onClickPersonalModal}
                      data-element="startBC3"
                      sx={{ height: 115 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                        <img src={bc3} height="75" width="105" alt="bc3" />
                        <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                            {i18n.t("Cargar un BC3")}
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {
                              "Sube tu archivo bc3 y empieza a trabajar en tu presupuesto"
                            }
                          </Typography>
                        </Box>
                        <img
                          src={higherThan}
                          width="24"
                          height="15"
                          alt="arrow"
                        />
                      </Box>
                    </CardActionArea>
                  </Card>

                  <Card variant="outlined">
                    <CardActionArea
                      data-testid="new-budget-option-pdf-planhopper-ai"
                      onClick={importPDFWithAI}
                      sx={{ height: 115 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                        <img
                          src={pdfPlanhopperAI}
                          height="75"
                          width="105"
                          alt="ai"
                        />
                        <Box sx={{ ml: 1, flex: 1, minWidth: 0, pr: 1 }}>
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            sx={{ mb: 0.5 }}
                          >
                            <Typography
                              sx={{
                                fontSize: 16,
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {"PDF a Planhopper con IA"}
                            </Typography>
                            <Chip
                              label="¡NUEVO!"
                              size="small"
                              sx={{
                                height: 18,
                                backgroundColor: "#F8D526",
                                color: "#252525",
                                fontSize: 9,
                                fontWeight: 700,
                              }}
                            />
                          </Stack>
                          <Typography sx={{ fontSize: 13 }}>
                            {
                              "Sube tu PDF y lo convertimos a presupuesto en Planhopper."
                            }
                          </Typography>
                        </Box>
                        <img
                          src={higherThan}
                          width="24"
                          height="15"
                          alt="arrow"
                        />
                      </Box>
                    </CardActionArea>
                  </Card>

                  <Card variant="outlined">
                    <CardActionArea
                      data-testid="new-budget-option-tcq-excel"
                      onClick={importTCQ}
                      sx={{ height: 115 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                        <img
                          src={excel}
                          height="75"
                          width="105"
                          alt="excel-tcq"
                        />
                        <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
                          <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                            {i18n.t("Plantilla Excel TCQ")}
                          </Typography>
                          <Typography sx={{ fontSize: 13 }}>
                            {i18n.t("project.tcq.uploadPrefix")}
                            <strong>{i18n.t("project.tcq.uploadBold")}</strong>
                            {i18n.t("project.tcq.uploadSuffix")}
                          </Typography>
                        </Box>
                        <img
                          src={higherThan}
                          width="24"
                          height="15"
                          alt="arrow"
                        />
                      </Box>
                    </CardActionArea>
                  </Card>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Card variant="outlined">
                  <CardActionArea
                    data-testid="new-budget-option-other-formats"
                    onClick={() => {
                      setOpenCreateFromOther(true)
                      setOpenModalOther(true)
                      setModalNew(false)
                    }}
                    sx={{ height: 115 }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
                      <img
                        src={startPlanhopper}
                        height="75"
                        width="105"
                        alt="other-formats"
                        style={{ filter: "grayscale(1)", opacity: 0.85 }}
                      />
                      <Box sx={{ ml: 1, flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                          {i18n.t("otherFormats")}
                        </Typography>
                        <Typography sx={{ fontSize: 13 }}>
                          {"Sube aquí archivos "}
                          <strong>{"CAD, Revit, TXT o DOC (Word)"}</strong>
                          {" y recibirás un correo cuando esté cargado."}
                        </Typography>
                      </Box>
                      <img
                        src={higherThan}
                        width="24"
                        height="15"
                        alt="arrow"
                      />
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ textAlign: "center" }}>
              <Typography sx={{ fontWeight: 700 }} component="div">
                ¿Dudas?
              </Typography>
              <Typography sx={{ mt: 1 }}>
                Haz clic{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://help.planhopper.com/en/help/articles/9805042-como-comenzar-con-planhopper"
                >
                  aquí
                </a>{" "}
                para conocer todos los formatos de carga disponibles
              </Typography>
            </Box>
          </Box>
        </Box>
      </Modal>

      {openModalPlantilla && (
        <ModalSelectPlantilla
          open={openModalPlantilla}
          setOpen={setOpenModalPlantilla}
        />
      )}

      {openCreateFromOther && (
        <ModalCreateFromExcel
          from="other"
          modal_first={openModalOther}
          setmodal_first={setOpenModalOther}
          contactos={Contacts}
        />
      )}

      {openCreateFromExcel && (
        <ModalCreateFromExcel
          from="excel"
          modal_first={openModalExcel}
          setmodal_first={setOpenModalExcel}
          contactos={Contacts}
        />
      )}
      {openCreateFromPDFAI && (
        <ModalCreateFromExcel
          from="other"
          uploadVariant="pdfAI"
          modal_first={openModalPDFAI}
          setmodal_first={setOpenModalPDFAI}
          contactos={Contacts}
        />
      )}
      {openCreateFromTCQ && (
        <ModalCreateFromExcel
          from="TCQ"
          modal_first={openModalTCQ}
          setmodal_first={setOpenModalTCQ}
          contactos={Contacts}
        />
      )}
      {entitlementDialog}
    </>
  )
}

ModalSelectTypeProject.propTypes = {
  modalNew: PropTypes.bool,
  setModalNew: PropTypes.func,
  setmodal_first: PropTypes.func,
  onClickPersonalModal: PropTypes.func,
}

export default ModalSelectTypeProject
